import { Component, OnInit } from '@angular/core';
import { Auth } from 'aws-amplify';
import * as AWS from 'aws-sdk';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit {


  constructor() { }

  ngOnInit(): void {
  }

}
